import { FC } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import { DividerProps } from "./Divider.types";
import StyledDivider, { StyledDividerWrapper } from "./Divider.styles";

const Divider: FC<DividerProps> = ({ className, ...props }) => {
	const block = new BemIt("Divider");

	return (
		<StyledDividerWrapper className={addClass(className).after(block)}>
			<StyledDivider {...props} />
		</StyledDividerWrapper>
	);
};

export default Divider;
